import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { catchError, Observable, switchMap, throwError } from 'rxjs';
import { UserService } from '../services/user.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  private isRefreshing = false;

  constructor(private userService: UserService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<Object>> {

    request = this.addTokenHeader(request);

    return next.handle(request).pipe(catchError(error => {

      if (error instanceof HttpErrorResponse && !request.url.includes('signInAdmin') && error.status === 401) {
        return this.handle401Error(request, next) as Observable<HttpEvent<Object>>;
      }
      return throwError(() => error);
    }));
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {

    if (!this.isRefreshing) {

      this.isRefreshing = true;

      if (this.userService.isUserAdmin || this.userService.isAccountant() || this.userService.isProspection()) {

        return this.userService.refreshToken().pipe(
          switchMap((res) => {
            this.isRefreshing = false;
            return next.handle(this.addTokenHeader(request));
          }),
          catchError((error) => {
            this.isRefreshing = false;

            if (error instanceof HttpErrorResponse && request.url.includes('refreshToken') && error.status === 401) {
              this.userService.logOut(true);
            }

            return throwError(() => error);
          })
        );
      }
    }

    return next.handle(request);

  }

  private addTokenHeader(request: HttpRequest<any>) {

    if (!request.url.includes(environment.endpoint.domainApi))
      return request;

    if (!this.userService.getLocalJWT)
      return request.clone({
        headers: request.headers
          .set('app-version', environment.appVersion)
          .set('user-event', this.userService.getUserEventFlag)
      });

    return request.clone({
      headers: request.headers.set('x-access-token', this.userService.getLocalJWT)
        .set('app-version', environment.appVersion)
        .set('user-event', this.userService.getUserEventFlag)
    });
  }
}
